// Module
var code = "<section class=\"content-section\"><div class=\"container\"><p>Dashboard: Logged in as HeadOffice user.</p><select ng-change=\"selectGym(selected)\" ng-model=\"selected\" ng-options=\"gym as gym[0] for gym in gyms\"><option value=\"\">Select Gym</option></select></div></section>\n";
// Exports
module.exports = code;